import CSS from 'csstype';
import GeneralButtonComponent from '../../components/button/GeneralButtonComponent';
import ImageAsync from '../../components/native/ImageAsync';
import { useAlert } from '../../hooks/useAlert';

const RefillMiniBarSection = () => {

    const alert = useAlert('¡Tu solicitud ha sido enviada satisfactoriamente!');

    const messageSuccess = (
        <>
            <p style={{ fontSize: '14px', color: '#000000' }}>
                Podrás <span style={{ color: '#FF4747' }}>cancelar</span> tu órden en cualquier momento desde esta <span className='bold' style={{ color: '#67BAAF' }}>app</span> o marcando <span style={{ color: '#67BAAF' }}>"3"</span> desde el teléfono de tu habitación.</p>

            <GeneralButtonComponent classes='mt-8 primary_btn hover:primary_btn text-white py-2 px-6' click={() => { alert.close() }}
                bgcolor='#67BAAF'>Aceptar</GeneralButtonComponent>
        </>
    );



    const handlePedido = () => {
        alert.fire(messageSuccess);
    }

    return (
        <div>
            <div style={advertenciaStyle}>
                <span style={{ fontSize: '13px', fontWeight: '600' }}>Condiciones de servicio:</span> <br />
                <span>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla accumsan, dui sit amet ultrices sodales, dui velit ornare erat, id hendrerit nisi nibh eu tellus.
                    </p>
                </span>
            </div>

            <div className='flex justify-start items-center mt-4'>
                <ImageAsync src="/assets/img/icons/clock-icon.svg" alt="Clock icon" />
                <div className='ml-4 flex flex-col'>
                    <span style={timeTextStyles}>
                        Todo el día en cualquier hora
                    </span>
                </div>
            </div>

            <p className='mt-4'>
                Estimado huésped, los tiempos de preparación de elementos son de aproximadamente 30 a 60 minutos dependiendo la demanda.
            </p>

            <p className='mt-4 mb-4'>
                El refill contiene lo siguiente:
            </p>

            <div className="grid grid-cols-2 gap-2 w-full">
                <div className='flex flex-col justify-center items-center'>
                    <div className='rounded-md border flex justify-center items-center' style={squadStyles}>
                        <ImageAsync src="assets/img/svg/coca_img.svg" alt="Coca cola" />
                    </div>
                    <span>
                        6 Refrescos mixtos
                    </span>
                </div>

                <div className='flex flex-col justify-center items-center'>
                    <div className='rounded-md border flex justify-center items-center' style={squadStyles}>
                        <ImageAsync src="assets/img/svg/cerveza_img.svg" alt="cerveza" />
                    </div>
                    <span>4 cervezas</span>
                </div>
                <div className='flex flex-col justify-center items-center'>
                    <div className='rounded-md border flex justify-center items-center' style={squadStyles}>
                        <ImageAsync src="assets/img/svg/agua_img.svg" alt="botella de agua" />
                    </div>
                    <span>
                        4 Botellas de Agua
                    </span>
                </div>
                <div className='flex flex-col justify-center items-center'>
                    <div className='rounded-md border flex justify-center items-center' style={squadStyles}>
                        <ImageAsync src="assets/img/svg/nestea_img.svg" alt="jugo nestea" />
                    </div>
                    <span>1 Nestea</span>
                </div>
            </div>


            <div className='text-center mt-4'>
                <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-2 px-6' click={handlePedido}
                    bgcolor='#67BAAF' > Solicitar Refill </GeneralButtonComponent>
            </div>
        </div>
    )
}

const timeTextStyles: CSS.Properties = {
    color: '#4B5563'
}

const advertenciaStyle: CSS.Properties = {
    backgroundColor: '#FFE36F',
    height: '114px',
    padding: '14px',
    fontSize: '12px',
    width: '100vw',
    marginLeft: '-14px',
    marginTop: '-14px'
}

const squadStyles: CSS.Properties = {
    width: '109px',
    height: '109px'
}

export default RefillMiniBarSection
